import { render, staticRenderFns } from "./TeachingScheduleManager.vue?vue&type=template&id=33a970d5"
import script from "./TeachingScheduleManager.vue?vue&type=script&lang=js"
export * from "./TeachingScheduleManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports